import React from "react";
import { useContext } from "react";
import { CompanyContext } from "../context/CompanyContext";

const Footer = () => {
  const { company } = useContext(CompanyContext);
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="text-white text-center py-4 mt-5"
      style={{ backgroundColor: "#198754" }}
    >
      <p>
        &copy; {currentYear} {company ? company.name : "Loading..."} . All
        Rights Reserved.
      </p>
    </footer>
  );
};

export default Footer;
